import { notify } from "components/common"
import { useEffect } from "react"

export const useErrorNotification = options => {
  useEffect(() => {
    options.isError && notify.error(options.error.message)
  }, [options.isError])
}
